import { namespace } from "./env"

export default class Utils {
  constructor() {
    this.conditions = {}
  }

  formulaProperties (item) {
    const { nearestLines, stations } = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))
    const conditions = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))
    switch (item[conditions.extractedRailLineInformation]) {
      case nearestLines.line1:
        return stations.name1
      case nearestLines.line2:
        return stations.name2
      case nearestLines.line3:
        return stations.name3
      case nearestLines.line4:
        return stations.name4
      case nearestLines.line5:
        return stations.name5
    }
  }

  formulaWalkingInfo (item) {
    const { nearestLines, minuteWalk } = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))
    const conditions = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))
    switch (item[conditions.extractedRailLineInformation]) {
      case nearestLines.line1:
        return minuteWalk.minute1
      case nearestLines.line2:
        return minuteWalk.minute2
      case nearestLines.line3:
        return minuteWalk.minute3
      case nearestLines.line4:
        return minuteWalk.minute4
      case nearestLines.line5:
        return minuteWalk.minute5
    }
  }

  formulaBusInfo (item) {
    const { nearestLines, stations, busStations, rideTime, walkFromBusStop } = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))
    const conditions = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))

    const busInfo = {}
    switch (item[conditions.extractedRailLineInformation]) {
      case nearestLines.line1:
        busInfo.trainStation = item[stations.name1]
        busInfo.busStation = item[busStations.name1]
        busInfo.rideTime = item[rideTime.minute1]
        busInfo.minuteFromBus = item[walkFromBusStop.minute1]
        break;
      case nearestLines.line2:
        busInfo.trainStation = item[stations.name2]
        busInfo.busStation = item[busStations.name2]
        busInfo.rideTime = item[rideTime.minute2]
        busInfo.minuteFromBus = item[walkFromBusStop.minute2]
        break;
      case nearestLines.line3:
        busInfo.trainStation = item[stations.name3]
        busInfo.busStation = item[busStations.name3]
        busInfo.rideTime = item[rideTime.minute3]
        busInfo.minuteFromBus = item[walkFromBusStop.minute3]
        break;
      case nearestLines.line4:
        busInfo.trainStation = item[stations.name4]
        busInfo.busStation = item[busStations.name4]
        busInfo.rideTime = item[rideTime.minute4]
        busInfo.minuteFromBus = item[walkFromBusStop.minute4]
        break;
      case nearestLines.line5:
        busInfo.trainStation = item[stations.name5]
        busInfo.busStation = item[busStations.name5]
        busInfo.rideTime = item[rideTime.minute5]
        busInfo.minuteFromBus = item[walkFromBusStop.minute5]
        break;
    }

    return busInfo;
  }

  formulaSalesPrice (item) {
    const conditions = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))
    let price = ''
    if (item[conditions.rangeForSale].length !== 0) {
      price = item[conditions.rangeForSale]
    } else if (item[conditions.rangeOfLandForSale].length !== 0) {
      price = item[conditions.rangeOfLandForSale]
    } else if (item[conditions.conditionalPriceRange].length !== 0) {
      price = item[conditions.conditionalPriceRange]
    }

    const wavyLine = /(~|〜|～)/
    if (wavyLine.test(price)) {
      let priceArr = price.split(wavyLine)
      price = `${priceArr[0]}${priceArr[1]}<br>${priceArr[2]}`
    }

    return price
  }

  setTrafficInfo (item) {
    const { nearestLines } = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))
    const conditions = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))
    let traffics = []

    switch (item[conditions.extractedRailLineInformation]) {
      case nearestLines.line1:
        traffics = this.checkTrafficInfo(1, item)
        break;
      case nearestLines.line2:
        traffics = this.checkTrafficInfo(2, item)
        break;
      case nearestLines.line3:
        traffics = this.checkTrafficInfo(3, item)
        break;
      case nearestLines.line4:
        traffics = this.checkTrafficInfo(4, item)
        break;
      case nearestLines.line5:
        traffics = this.checkTrafficInfo(5, item)
        break;
    }

    return traffics
  }

  checkTrafficInfo (num, item) {
    const { stations, minuteWalk } = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))

    let arr = []
    Object.entries(stations).map((s, idx) => {
      let obj = {}
      if (!s[0].includes(num) && item[s[1]].length !== 0) {
        obj.station = item[s[1]]
      }

      let minuteArr = Object.entries(minuteWalk)
      if (
        !minuteArr[idx][0].includes(num) &&
        String(item[minuteArr[idx][1]]).length !== 0
      ) {
        obj.minute = item[minuteArr[idx][1]]
      }

      if (obj.minute !== undefined) {
        arr.push(obj)
      } else if (obj.station !== undefined && obj.minute === undefined) {
        arr.push(this.checkBusInfo(item, num, obj))
      }
    })

    return arr
  }

  checkBusInfo (item, num, obj) {
    const { busStations, rideTime, walkFromBusStop } = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))

    let info = obj

    Object.entries(busStations).map((b, idx) => {
      if (!b[0].includes(num) && item[b[1]].length !== 0) {
        info.busStation = item[b[1]]
      }

      let rideTimeArr = Object.entries(rideTime)
      if (
        !rideTimeArr[idx][0].includes(num) &&
        String(item[rideTimeArr[idx][1]]).length !== 0
      ) {
        info.rideTime = item[rideTimeArr[idx][1]]
      }

      let walkFromBusArr = Object.entries(walkFromBusStop)
      if (
        !walkFromBusArr[idx][0].includes(num) &&
        String(item[walkFromBusArr[idx][1]]).length !== 0
      ) {
        info.walkFromBusStop = item[walkFromBusArr[idx][1]]
      }
    })

    return info
  }
}
